var _path, _mask, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivation = function SvgActivation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10Z",
    fill: "#fff"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "activation_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10A10 10 0 0 0 10 0v10h10Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10A10 10 0 0 0 10 0v10h10Z",
    fill: "#69B6AA",
    stroke: "#69B6AA",
    strokeWidth: 6,
    mask: "url(#activation_svg__a)"
  })));
};
export default SvgActivation;